import React, { Component } from 'react'
import { observer } from 'mobx-react'
import * as R from 'ramda'
import BenchmarkingModalShell from '../../../Modals/BenchmarkingModalShell'

@observer
class BenchmarkingModal extends Component {
    changeYears = ({ value }) => {
        const { reportStore } = this.props
        const { yoyComparisons, lastYearSurveys, reloadComparison } = reportStore
        yoyComparisons.clear()
        value.forEach((v) => {
            yoyComparisons.set(v, lastYearSurveys.find(({ value: sv }) => sv === v))
        })
        reloadComparison()
    }

    changePeriods = ({ value }) => {
        const { reportStore } = this.props
        const { changeBenchmarkPeriod, benchmarkPeriods } = reportStore
        const period = benchmarkPeriods.find((p) => p.value === value[0])
        if (period) changeBenchmarkPeriod({ period: period.period })
    }

    changeBenchmarks = ({ value }) => {
        const { reportStore } = this.props
        const { benchmarks2, benchmarkOptions } = reportStore
        benchmarks2.clear()
        value.forEach((b) => {
            benchmarks2.set(b, benchmarkOptions.find((o) => o.value === b))
        })
    }

    getIndustryName = (appStore) => {
        const industries = R.pathOr(undefined, ['client', 'industries'], appStore)
        const industryCode = R.pathOr(
            undefined, ['survey', 'metadata', 'productInfo', 'industrySpecificInfo', 'industry'], appStore,
        )
        const industry = industries.find((i) => i.code === industryCode)
        return industry?.name
    }

    render() {
        const { reportStore, showBenchmarking, toggleShowBenchmarking } = this.props
        const { appStore } = reportStore
        const { survey } = appStore

        const showBenchmarks = R.pathOr(undefined, ['metadata', 'taxonomy', 'surveyType'], survey) === 'PE'
        const benchmarkOptions = showBenchmarks ? reportStore.benchmarkOptions : []
        const periodOptions = reportStore.benchmarkPeriods
        const yearOptions = reportStore.lastYearSurveys.filter((y) => !!y.label)

        const selectedBenchmarks = Array.from(reportStore.benchmarks2)
            .filter(([, v]) => !!v)
            .map(([key]) => key)
        const selectedYears = Array.from(reportStore.yoyComparisons).map(([key]) => key)
        const selectedPeriods = [reportStore.benchmarkPeriod.duration]

        const industry = this.getIndustryName(appStore, reportStore)

        return (
            <BenchmarkingModalShell
                storeType="report"
                industry={industry}
                show={showBenchmarking}
                onClose={toggleShowBenchmarking}
                trackBenchmarksComparisonsApplied={reportStore.trackBenchmarksComparisonsApplied}
                langcode={appStore.langcode}
                benchmarkOptions={benchmarkOptions}
                selectedBenchmarks={selectedBenchmarks}
                customBenchmarkTags={reportStore.benchmarkTags}
                changeBenchmarks={this.changeBenchmarks}
                periodOptions={periodOptions}
                selectedPeriods={selectedPeriods}
                changePeriods={this.changePeriods}
                yearOptions={yearOptions}
                selectedYears={selectedYears}
                changeYears={this.changeYears}
            />
        )
    }
}

export default BenchmarkingModal
